import React, { useState, useCallback, useEffect, useContext, useRef } from "react";
import { Routes, Route, Navigate, useHref, useNavigate } from "react-router-dom";
import SideMenu from "./components/menu/Menu";
import Navbar from "./components/navbar/Navbar";
import MenuContextProvider from "./store/MenuContextProvider";
import OrgIdContextProvider from "./store/OrgIdContextProvider";
import TechnicalOverview from "./pages/TechnicalOverview";
import InvoiceObject from "./pages/InvoiceObject";
import APIPlayground from "./pages/APIPlayground";
import ObjectPlayground from "./pages/ObjectPlayground";
import MyProfile from "./pages/MyProfile";
import AddUser from "./pages/AddUser";
import Billing from "./pages/Billing";
import ChangePaymentPlan from "./pages/ChangePaymentPlan";
import OrganizationSettings from "./pages/OrganizationSettings";
import EditInvoices from "./pages/EditInvoices";
import Dashboard from "./pages/Dashboard";
import NotLoggedIn from "./components/NotLoggedIn/NotLoggedIn";
import AllClients from "./pages/AllClients";
import NotTransformer from "./components/NotTransformer/NotTransformer";
import useWindowSize from "./hooks/useWindowSize";
import SuperSession from "./components/superSession/SuperSession";
import FormTest from "./pages/FormTest";
import EditServices from "./pages/EditServices";
import NotMainOrg from "./components/notMainOrg/NotMainOrg";
import AddCustomer from "./pages/AddCustomer";
import IntegrationWizard from "./pages/IntegrationWizard";
import ClientWizard  from "./pages/ClientWizard"
import { OrgIdContext, ClientTypes } from "./store/orgId_context";
import { SideMenuProSidebar } from "./components/navbar/SideMenuProSidebar";
import QuickStart from "./pages/QuickStart";
import CustomerRelationsComponent from "./components/clientWizard/customerRelations/CustomerRelationsComponent";
import PackagesPage from "./components/clientWizard/packages/PackagesPage";
import ConnectionKeyRequest from "./components/clientsComponents/ConnectionKeyRequest";
import UserUIStateContextProvider from "./store/UserUIStateContextProvider";
import NotImplemented from "./components/UI/NotImplemented";
import DashboardPlaceholder from "./components/dashboardComponents/DashboardPlaceholder";
import EditIntegrationInvoices from "./pages/EditIntegrationInvoices";
import Complexities from "./pages/Complexities";
import LoadingDots from "./components/UI/LoadingDots";
import IntegrationWizard2 from "./pages/IntegrationWizard2";
import IntegrationSteps from "./pages/IntegrationSteps";
import IntegrationDocs from "./pages/IntegrationDocs";
import IntegrationWizardFull from "./pages/IntegrationWizardFull";
import UpdateCustomer from "./pages/UpdateCustomer";
import IntegrationAddUser from "./pages/IntegrationAddUser";
import {NotificationContainer} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import ThemeMaker from "./pages/ThemeMaker";
import Theme from "./pages/Theme";
import LoggedOutWrapper from "./components/loggedout/LoggedOutWrapper";
import Login from "./pages/Login";
import useSessionInfo from "./hooks/useSessionInfo";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import SignUp from "./pages/SignUp";
import SignUpNew from "./pages/SignUpNew";
import MailGenerator from "./pages/MailGenerator";
import Devices from "./pages/Devices";
import InvoiceSettings from "./pages/InvoiceSettings";
import PreMadePlugin from "./pages/PreMadePlugin";
import OperationMode from "./pages/OperationMode";
import REIInvoices from "./pages/REIInvoices";
import { MenuContext } from "./store/menu_context";
import {BaseContext} from "./store/basepath";
import ConfirmEmail from "./pages/ConfirmEmail";
import ConfirmEmailLogged from "./pages/ConfirmEmailLogged";
import { ThemeContext, Themes } from "./store/ThemeContext";
import AllInvoices from "./pages/AllInvoices";
import AllInvoicesREI from "./pages/AllInvoicesREI";
import AllReports from "./pages/AllReports";
import UserSettings from "./pages/UserSettings";
import AIExtractionStudio from "./pages/AIExtractionStudio";
import gwhale from "guidewhale";
import axios from "axios";
import { DDD } from "./lib/ddd/ddd";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [sessionContent, setSessionContent] = useState(false);
  //const [isTransformer, setIsTransformer] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [triggerRerender, setTriggerRerender] = useState(null);
  const navigate = useNavigate();
  
  const { width } = useWindowSize();
  const { isTransformer , isIntegrator, ISVCustomer, integrationNotFinished, clientType, sessionInfo } = useContext(OrgIdContext);
  const {preview, theme} = useContext(ThemeContext);
  const {changeBasePath, basepath} = useContext(BaseContext);
  const gwhaleInitialized = useRef(false);

  useEffect(() => {
    if(process.env.REACT_APP_API_ENDPOINT)
      return;
    if(!sessionInfo) return;
    if(sessionInfo?.Extended?.Theme === Themes.GVC)
      return;
    if (window.plugSDK && typeof window.plugSDK.init === "function") {
      window.plugSDK.init({
        app_id: "don:core:dvrv-us-1:devo/srd5iU6x:plug_setting/1",
      });
    } else {
      console.warn("plugSDK is not available on window");
    }
  }, [sessionInfo]);

  useEffect(() => {
    /* if (!sessionInfo) return;

    if (gwhaleInitialized.current) return;
    gwhaleInitialized.current = true;
    const hostname = window.location.hostname;
    const isDev = hostname === "localhost" || hostname.startsWith("127.") || hostname.startsWith("dev.");
    let whaleInst = isDev ?  "test-17bb7170" : "prod-17bb7170";

    const ddd = new DDD(apiRequestAddress);
    ddd.Rpc_ExecuteExtension("EUeInvoices.GuideWhaleSignature", {Id : sessionInfo?.User?.Id}).then(res => {
      if(!res?.result?.Result) console.error("GuideWhale signature fetch error");
      gwhale.init(whaleInst, {
        signature: res?.result?.Result,
        user : {
          user_id : sessionInfo?.User?.Id,
          email : sessionInfo?.Profile?.Email,
          email_verified : sessionInfo?.Profile?.MailVerified || false,
          name : sessionInfo?.Profile?.Name,
          last_name : sessionInfo?.Profile?.LastName,
          mobile_phone : sessionInfo?.Profile?.MobilePhone,
          username : sessionInfo?.User?.PrimaryUsername,
          country : sessionInfo?.Profile?.Country,
          culture : sessionInfo?.Profile?.Culture,
          created : sessionInfo?.User?.CreateDate,
        },
        company : {
          company_id: sessionInfo?.Organization?.Id,
          company_aid : sessionInfo?.Extended?.AboutOrgId,
          title : sessionInfo?.Organization?.Title,
          account_balance : sessionInfo?.Extended?.AccountBalance,
          blocked : sessionInfo?.Extended?.Blocked || false,
          blocked_fisc : sessionInfo?.Extended?.BlockedFISC || false,
          blocked_rei : sessionInfo?.Extended?.BlockedREI || false,
          client_type : sessionInfo?.Extended?.ClientType, //ISV, Company, null
          country_code : sessionInfo?.Organization?.CountryCode,
          iei_package : sessionInfo?.Extended?.CurrentPackages?.IEI_Package?.Trial === false ? false : true,
          rei_package : sessionInfo?.Extended?.CurrentPackages?.REI_Package?.Trial === false ? false : true,
          fisc_package : sessionInfo?.Extended?.CurrentPackages?.FISC_Package?.Trial === false ? false : true,
          isv_customer : sessionInfo?.Extended?.ISVCustomer,
          mode_iei : sessionInfo?.Extended?.ModeIEI, //PROD, TEST
          mode_rei : sessionInfo?.Extended?.ModeREI,
          refcode : sessionInfo?.Extended?.RefCode,
          integrationNotFinished : sessionInfo?.Extended?.IntegrationNotFinished,
          isAPIKeyProdSetted : sessionInfo?.Extended?.IsAPIKeyProdSetted,
          isCertificatePassSetted : sessionInfo?.Extended?.IsCertificatePassSetted,
          isCertificateSetted : sessionInfo?.Extended?.IsCertificateSetted,
          isFiscalization : sessionInfo?.Extended?.IsFiscalization,
          missingProfileInformation : null, //TODO are set elswhere via setCompanyProperties: true, false, null
          missingProfileText : null, //TODO
          clients : null, //TODO are set elswhere via setCompanyProperties: number
        }
      });
    });
    

    console.log("Gwhale init called", "test-17bb7170", {
        gdpr: true, 
        gdpr_consent: true,
        user : {
          email : sessionInfo?.User?.Email
      }
    }); */

  }, [sessionInfo]);

  const loadOnboardingScript = () => {
    if (!document.getElementById("f2f-sdk")) {
      const script = document.createElement("script");
      script.id = "f2f-sdk";
      script.src = "https://sdk.face2face.io/f2f-sdk.min.js";
      script.dataset.org_id = "673b62c506b59bd3d4aebb1c";

      document.head.appendChild(script);
    }
  }

  const onSessionLoadedHandler = useCallback(
    (response, isTransformer, companyData) => { 
      
      setSessionContent(response);
      //setIsTransformer(isTransformer);
      setIsLoaded(true);
      setCompanyData(companyData);
      
      if (!response || !companyData?.Organization) {
        //debugger;
        if(companyData?.Organization===null && companyData?.User?.Id!=="00000000-0000-0000-0000-000000000000"){
          if(window.location.pathname?.indexOf("sign-up")>-1) return;
            window.location.href='dashboard-sign-up';
            //window.location.reload();
        }else{
          if(window.location.pathname?.indexOf("sign-up")>-1) return;
          if(window.location.pathname?.indexOf("resetpassword")>-1 || window.location.pathname?.indexOf("confirmrequest") > -1 || window.location.pathname?.indexOf("confirmemail") > -1) return;
          navigate('/dashboard-login', { replace: true });
        }
      }
      if(companyData?.Extended?.InitialComponent)
        window.location.href='@'+companyData?.Extended?.InitialComponent;
      if(process.env.REACT_APP_API_ENDPOINT)    //dont redirect in dev
        return;
      /*if(companyData?.Extended?.IntegrationNotFinished)
        navigate("/quickstart")*/
    },
    []
  );

//https://www.npmjs.com/package/reactour

  /*let pathNames = useHref("/")?.replace(/^\/|\/$/g, '').split("/") || [];
  let integration = pathNames.length > 0 && pathNames[0].toLocaleLowerCase() == "integration";
  const [isIntegration, setIsIntegration] = useState(integration);*/
  let availableBasePaths = ["integration", "administration", "flow", "mycompany", "packages", "dist-channels"];
  let pathNames = useHref("/")?.replace(/^\/|\/$/g, '').split("/") || [];
  let basePath = pathNames.length > 0 && pathNames[0].toLocaleLowerCase();
  const isBasePath = availableBasePaths.indexOf(basePath) >= 0;

  useEffect(() => {
    if(!isBasePath) return;
    changeBasePath(basePath);
  },[]);

  // Server-side routing doesn't currently serve the SPA directly at
  // /dashboard-confirmrequest (confirmed 2026-08-13: a hard navigation there bounces to
  // /web/myaccount?returnUrl=... instead, unlike /login which loads correctly) — so the
  // legacy resetpasswordconfirm page now redirects through /login?confirmId=X instead.
  // Once the SPA is actually running (regardless of which route the server happened to
  // serve it at), this forwards on with a pure client-side navigate() — no further server
  // round-trip, so the missing server rule doesn't matter for this hop. Deliberately
  // unconditional on session state (fires on mount, not gated behind hasSession/isLoaded)
  // since onSessionLoadedHandler above already has its own carve-out for staying on
  // dashboard-confirmrequest once there, confirming the destination itself needs no
  // session to be present yet — this only fixes how you get there.
  useEffect(() => {
    const confirmId = new URLSearchParams(window.location.search).get('confirmId');
    if (!confirmId) return;
    navigate('/dashboard-confirmrequest?id=' + encodeURIComponent(confirmId), { replace: true });
  }, []);

  const onRequireRerender = () => {
    setTriggerRerender(true);
  };
  
  const { hasSession, clientData, sessionData, blockedData, onCloseBlock } = useSessionInfo(
    onSessionLoadedHandler,
    triggerRerender
  );

  return (
    <div className="w-100 d-flex" style={{height:"100vh"}}>
      <MenuContextProvider>
        <UserUIStateContextProvider>
        <NotificationContainer/>
        {basepath === "packages" && sessionContent && companyData?.Organization&&  <><PackagesPage /></>}
        {basepath === "dist-channels" && sessionContent && companyData?.Organization && <><EditServices /></>}
        {(!sessionContent||companyData?.Organization===null) && isLoaded && <>
          <LoggedOutWrapper>
            <Routes>
              <Route path="login" element={<Login />}/>
              <Route path="dashboard-login" element={<Login />}/>
              <Route path="resetpassword" element={<ResetPassword />}/>
              <Route path="confirmemail" element={<ConfirmEmail />}/>
              <Route path="dashboard-resetpassword" element={<ResetPassword />}/>
              <Route path="dashboard-confirmrequest" element={<ChangePassword />}/>
              <Route path="sign-up" element={<SignUpNew />}/>
              <Route path="dashboard-sign-up" element={<SignUpNew />}/>
              <Route path="@dashboard-sign-up" element={<SignUpNew />}/>
              {!sessionContent && <>
                <Route path="*" element={<Login />} />
              </>}
              {sessionContent && <>
                <Route path="*" element={<SignUpNew />} />
              </>}
            </Routes>
          </LoggedOutWrapper>
        </>}
        {(basepath !== "packages" && basePath !=="dist-channels") && sessionContent && companyData?.Organization && <>
          {width > 768 && <SideMenu/>}
          {/*<SideMenuProSidebar />*/}
          {/*<OrgIdContextProvider>*/}
            <section className="d-flex flex-column w-100">
              <Navbar
                onSessionLoadedHandler={onSessionLoadedHandler}
                triggerRerender={triggerRerender}
                hasSession={hasSession}
                clientData={clientData}
                sessionData={sessionData}
                blockedData={blockedData}
                onCloseBlock={onCloseBlock}
              />
              {!isLoaded && /*<DashboardPlaceholder/>*/ <LoadingDots/>}
              {sessionContent /*&& isTransformer*/ && (<>
                <Routes>
                  {!isBasePath /*&& (isTransformer || ISVCustomer || isIntegrator)*/&& 
                    <Route index element={<Navigate to="/dashboard" replace />} />
                  }
                  {isBasePath && basePath==="integration" &&
                    <Route index element={<Navigate to="/technical-overview" replace />} />
                  }
                  {isBasePath && basePath==="administration" &&
                    <Route index element={<Navigate to="/dashboard" replace />} />
                  }
                  {isBasePath && basePath==="flow" &&
                    <Route index element={<Navigate to="/my-profile" replace />} />
                  }
                  {isBasePath && basePath==="mycompany" &&
                    <Route index element={<Navigate to="/issued-invoices" replace />} />
                  }
                  
                  <Route path="admin" element={<Navigate to="/dashboard" replace />}/>
                  <Route path="adminnew" element={<Navigate to="/dashboard" replace />}/>
                  <Route path="admin-transformer" element={<Navigate to="/dashboard" replace />}/>
                  <Route path="admin-transformer-new" element={<Navigate to="/dashboard" replace />} />
                  
                  
                  <Route path="technical-overview" element={<TechnicalOverview />}/>
                  <Route path="customer-relations" element={<CustomerRelationsComponent />} />
                  <Route path="packages" element={<PackagesPage />} />
                  <Route path="invoice-object" element={<InvoiceObject />} />
                  <Route path="api-playground" element={<APIPlayground />} />
                  <Route path="dddi-save" element={<APIPlayground />} />
                  <Route path="object-playground" element={<FormTest />} />
                  
                  <Route path="testing" element={<ConnectionKeyRequest/>} />
                  <Route path="integration-wizard" element={<IntegrationWizard2 />} />
                  <Route path="integration-wizard-step" element={<IntegrationSteps />} />
                  <Route path="integration-wizard-return" element={<IntegrationDocs />} />
                  <Route path="integration-wizard-full" element={<IntegrationWizardFull/>} />
                  <Route path="quickstart" element={<QuickStart />} />
                  <Route path="confirmemail" element={<ConfirmEmailLogged />} />
                  <Route path="client-init" element={<ClientWizard />} />
                  {/* <Route path="finish" element={<Finish />} /> */}
                  <Route path="my-profile" element={<MyProfile companyData={companyData} />}/>
                  <Route path="billing" element={<Billing />} />
                  <Route path="change-payment-plan" element={<ChangePaymentPlan />}/>
                  <Route path="issued-invoices-old" element={<EditInvoices />} />
                  <Route path="edit-invoices" element={<AllInvoices filter='DeviceId__AssignedTo <> "CKI"'/>} />
                  <Route path="issued-invoices" element={<AllInvoices filter='DeviceId__AssignedTo <> "CKI"'/>} />
                  <Route path="received-invoices-old" element={<REIInvoices />} />
                  <Route path="received-invoices" element={<AllInvoicesREI />} />
                  <Route path="e-reporting" element={<AllReports/>} />
                  <Route path="ai-extraction" element={<AIExtractionStudio />} />
                  <Route path="invoice-settings" element={<InvoiceSettings />} />
                  <Route path="premade-plugins" element={<PreMadePlugin />} />
                  <Route path="operation-mode" element={<OperationMode />} />
                  {/* <Route path="sent-integration-invoices" element={<EditIntegrationInvoices />} /> */}
                  <Route path="sent-integration-invoices" element={<AllInvoices filter='DeviceId__AssignedTo = "CKI"' isTest={true}/>} />
                  <Route path="about-complexities" element={<Complexities />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="clients" element={<AllClients iframeUrl="/mycompany" />} />
                  <Route path="clients-flow" element={<AllClients iframeUrl="@invt" />} />
                  <Route path="add-user" element={<AddUser />} />
                  <Route path="form-test" element={<ObjectPlayground />} />
                  {/* <Route path="service-credentials" element={<EditServices />} /> */}
                  <Route path="api-keys-and-credentials" element={<EditServices />} />
                  <Route path="presets-devices" element={<Devices />} />
                  <Route path="user-settings" element={<UserSettings />} />
                  <Route path="add-customer" element={<AddCustomer />} />
                  <Route path="update-customer" element={<UpdateCustomer />} />
                  <Route path="integration-add-user" element={<IntegrationAddUser />} />
                  <Route path="themes-creator" element={<ThemeMaker />} />
                  <Route path="mail-creator" element={<MailGenerator />} />
                  <Route path="maintainer-organization" element={<Theme />} />
                  <Route path="organization-settings" element={<OrganizationSettings/>} />

                  <Route path="add-attachments" element={<NotImplemented/>} />
                  <Route path="storno" element={<NotImplemented/>} />
                  <Route path="advance-invoice" element={<NotImplemented/>} />
                  <Route path="partial-corrections" element={<NotImplemented/>} />
                  <Route path="credit-notes" element={<NotImplemented/>} />
                  <Route path="advance-as-payment" element={<NotImplemented/>} />
                  <Route path="accounting-service" element={<NotImplemented/>} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
                </>
              )}
              {sessionContent &&
                companyData.Organization &&
                !(isTransformer===true || clientType===ClientTypes.ISV) &&
                sessionStorage.getItem("mainOrgId") &&
                sessionStorage.getItem("mainOrgId") !==companyData.Organization.Id &&
                basePath !== "mycompany" && (
                  <>
                  {/* <NotMainOrg onRequireRerender={onRequireRerender} /> */}
                  </>
                  )}
              {
              /* sessionContent &&
                  companyData.Organization &&
                  !isTransformer &&
                  sessionStorage.getItem("mainOrgId") ===
                    companyData.Organization.Id && <NotTransformer />
                */
              }
              {!sessionContent && isLoaded && <NotLoggedIn />}
              {sessionContent && !companyData.Organization && <SuperSession />}
            </section>
          {/*/<OrgIdContextProvider>*/}
        </>}
        </UserUIStateContextProvider>
      </MenuContextProvider>
    </div>
  );
}

export default App;
